import { Component, OnInit } from '@angular/core';
import { AuditLogService, AuditLogDto } from './audit-log.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-audit-log-list',
  templateUrl: './audit-log-list.component.html',
  styleUrls: ['./audit-log-list.component.css']
})
export class AuditLogListComponent implements OnInit {
  loading = false;
  page = 1;
  pageSize = 20;
  total = 0;

  // Filters
  entityType = '';
  action = '';
  userId = '';
  startDate = '';
  endDate = '';

  items: AuditLogDto[] = [];

  showModal = false;
  modalChanges = '';

  constructor(private svc: AuditLogService, private notify: NotificationService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    const params: any = { page: this.page, pageSize: this.pageSize };
    if (this.entityType) params.entityType = this.entityType;
    if (this.action) params.action = this.action;
    if (this.userId) params.userId = this.userId;
    if (this.startDate) params.startDate = this.startDate;
    if (this.endDate) params.endDate = this.endDate;

    this.svc.list(params).subscribe({
      next: (res: any) => {
        this.items = res?.data ?? (Array.isArray(res) ? res : []);
        this.total = res?.meta?.total ?? this.items.length;
        this.loading = false;
      },
      error: (err) => {
        console.error('[AuditLog] erro ao listar', err);
        this.notify.showError('Erro ao carregar auditoria');
        this.loading = false;
      }
    });
  }

  resetFilters(): void {
    this.entityType = '';
    this.action = '';
    this.userId = '';
    this.startDate = '';
    this.endDate = '';
    this.page = 1;
    this.load();
  }

  onPageChange(p: number) {
    this.page = p;
    this.load();
  }

  viewChanges(item: AuditLogDto) {
    this.modalChanges = item.changes || '';
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.modalChanges = '';
  }

  displayEnd(): number {
    const end = this.page * this.pageSize;
    return end > this.total ? this.total : end;
  }
}
